<template lang="pug">
GmapMap(
  ref="gmap"
  :center="center"
  :zoom="zoom"
  map-type-id="terrain"
  style="width: 100%; height: 400px"
  @bounds_changed="updateBounds"
 )
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'

export default {
  name: 'MediaMapFilter',
  data() {
    return {
      center: { lat: 48.137154, lng: 11.576124 }, // z. B. München
      zoom: 5,
      debounceTimer: null
    }
  },
  computed: {
    ...mapGetters({ filter:'media/filter' }),
  },
  methods: {
    // ...mapActions({ updateFilter: 'media/updateFilter' }),
    updateBounds() {
      // debounce, um nicht bei jedem kleinen Schwenk neu zu laden
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        const map = this.$refs.gmap.$mapObject
        const mapBounds = map.getBounds()
        if (!mapBounds) return

        const ne = mapBounds.getNorthEast()
        const sw = mapBounds.getSouthWest()

        const bounds = {
          north: ne.lat(),
          east: ne.lng(),
          south: sw.lat(),
          west: sw.lng()
        }

         this.$emit('update-map-bounds', bounds);
      }, 500)
    }
  }
}
</script>
